export const SET_APP_CULTURE = 'SET_APP_CULTURE';

export function setCulture(culture: string) {
    return {
        type: SET_APP_CULTURE,
        culture
    };
}
